import React, { Component } from 'react';
import * as R from 'ramda';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { stringify as stringifyQueryString, parse as parseQueryString } from 'qs';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import DropdownToggle from 'reactstrap/lib/DropdownToggle';
import DropdownMenu from 'reactstrap/lib/DropdownMenu';
import Button from 'reactstrap/lib/Button';
import {
  LangSwitcher as LangSwitcherCore,
  RecommendedGames as RecommendedGamesCore,
  FormattedTag,
  RouteLink
} from 'core/components';
import {
  withUser,
  withModalActions,
  withCoreComponent,
  withUserAgent,
} from 'core/hocs';
import { USER_FIELDS, ES_LOCALES_LIST } from 'core/constants';
import {
  getEnv,
  wrapRoute2Locale,
  canUseDOM,
  isEmptyOrNil
} from 'core/helpers';
import { GamesSearchPortal } from 'components/games-search/games-search-portal';
import { CasinoHeader } from 'components/header/casino-header/casino-header';
import { menuItems } from 'components/header/menu-items';
import { IconUser } from 'components/icons/icon-user/icon-user';
import { UserBalance } from 'components/user-balance/user-balance';
import { UserInfoAndLoyalty } from 'components/user-info-and-loyalty/user-info-and-loyalty';
import { SidebarMenu } from 'components/sidebar/sidebar-menu/sidebar-menu';
import { SignInButtons } from 'components/header/sign-in-buttons/sign-in-buttons';
import { CasinoHeaderMobile } from 'components/header/casino-header/casino-header-mobile';
import { IconLogo } from 'components/icons/icon-logo/icon-logo';
import { ProfileModal } from 'components/modals/profile-modal/profile-modal';
import DropdownWithHover from 'components/dropdown-with-hover/dropdown-with-hover';
import { GC_LICENSE_BY_DOMAIN_LINK, GC_LICENSE_BY_DOMAIN_IMAGE } from 'components/license-seal/license-seal';
import { GA } from 'helpers/ga';
import { YM } from 'helpers/ym';
import { withThemeMode } from '../../hocs/with-theme-mode';

import { SportsbookSpinner } from './sportsbook-spinner/sportsbook-spinner';
import {
  SPORTSBOOK_POST_MESSAGE_TYPES,
  MODAL_IDS,
  AUTH_TYPES,
  SIDE_MODAL_IDS,
} from '../../constants';

import './sportsbook.scss';

const getSportsbookEnv = () => getEnv('PROJECT_ENV') === 'production' ? 'prod-ns' : 'staging-ns';

const parsePage = (search) => {
  let matched;

  try {
    matched = search && decodeURIComponent(search).match(/page=(.*)$/);
  } catch (_) {
    //
  }

  if (matched && matched.length > 1) {
    return matched[1];
  }

  return null;
};

const prepareFooterLink = (group, idx) => {
  if (group === 1) {
    if (idx === 0) {
      return '/games';
    }

    if (idx === 1) {
      return '/games/live';
    }

    if (idx === 2) {
      return '/games/slot';
    }

    // if (idx === 3) {
    //   return '/tournaments';
    // }

    if (idx === 3) {
      return '/sportsbook';
    }
  }

  if (group === 2) {
    // if (idx === 0) {
    //   return '/payments';
    // }

    if (idx === 1) {
      return '/about';
    }

    if (idx === 2) {
      return '/terms';
    }

    if (idx === 3) {
      return '/betting-rules';
    }

    if (idx === 4) {
      return '/bonus-terms';
    }

    // if (idx === 5) {
    //   return '/anti-money-laundering';
    // }
    //
    // if (idx === 6) {
    //   return '/refund-policy';
    // }
    //
    // if (idx === 7) {
    //   return '/privacy-policy';
    // }

    // if (idx === 8) {
    //   return '/affiliate';
    // }
    //
    // if (idx === 9) {
    //   return '/responsible-gaming';
    // }
    //
    // if (idx === 10) {
    //   return '/faq';
    // }
    //
    // if (idx === 11) {
    //   return '/self-exclusion';
    // }
    //
    // if (idx === 12) {
    //   return '/dispute-resolution';
    // }
    //
    // if (idx === 13) {
    //   return '/fairness-and-rng';
    // }
    //
    // if (idx === 14) {
    //   return '/kyc';
    // }
  }

  if (group === 3) {
    if (idx === 0) {
      return '/affiliate';
    }

    if (idx === 1) {
      return '/responsible-gaming';
    }

    if (idx === 2) {
      return '/faq';
    }

    // if (idx === 3) {
    //   return '/self-exclusion';
    // }
    //
    // if (idx === 4) {
    //   return '/dispute-resolution';
    // }
    //
    // if (idx === 5) {
    //   return '/fairness-and-rng';
    // }
    //
    // if (idx === 6) {
    //   return '/kyc';
    // }
    // if (idx === 0) {
    //   return formatMessage({ id: 'footer.social.url.facebook', defaultMessage: 'none' });
    // }

    // if (idx === 1) {
    //   return formatMessage({ id: 'footer.social.url.twitter', defaultMessage: 'none' });
    // }

    // if (idx === 2) {
    //   return formatMessage({ id: 'footer.social.url.instagram', defaultMessage: 'none' });
    // }

    // if (idx === 3) {
    //   return formatMessage({ id: 'footer.social.url.tiktok', defaultMessage: 'none' });
    // }

    // if (idx === 4) {
    //   return formatMessage({ id: 'footer.social.url.pinterest', defaultMessage: 'none' });
    // }

    // if (idx === 5) {
    //   return formatMessage({ id: 'footer.social.url.telegram', defaultMessage: 'none' });
    // }

    // if (idx === 6) { // to-do update the idx after sb team provides the actual one
    //   return formatMessage({ id: 'footer.social.url.line', defaultMessage: 'none' });
    // }
  }

  return '/';
};

const prepareHeaderLink = (idx) => {
  if (idx === 1) {
    return '/';
  }

  if (idx === 2) {
    return '/casino/live';
  }

  if (idx === 3) {
    return '/promos';
  }

  if (idx === 4) {
    return '/casino/slot';
  }

  if (idx === 5) {
    return '/casino/jackpots';
  }

  return '/';
};

const prepareProfileLink = (idx) => {
  if (idx === 0) {
    return '/profile';
  }

  if (idx === 1) {
    return '/profile/gifts';
  }

  if (idx === 2) {
    return '/profile/deposit';
  }

  if (idx === 3) {
    return '/profile/withdrawal';
  }

  if (idx === 4) {
    return '/profile/banking-history';
  }

  if (idx === 5) {
    return '/profile/verification';
  }

  if (idx === 6) {
    return '/profile/limits';
  }

  return '/';
};

const prepareIframeSrc = ({
  locale,
  sessionKey,
  currency = 'USD',
  parent,
  page,
  isLive,
  isDark,
}) => {
  const license = GC_LICENSE_BY_DOMAIN_LINK;
  const licenseImage = GC_LICENSE_BY_DOMAIN_IMAGE;

  let qp = {
    sessionKey,
    currency,
    parent,
    license,
    licenseImage,
  };
  let targetLocale = locale;

  if (ES_LOCALES_LIST.includes(locale)) {
    targetLocale = `es-${locale}`;
  } else if (locale === 'br') {
    targetLocale = 'pt-br';
  } else if (locale === 'au') {
    targetLocale = 'en-au';
  } else if (locale === 'nz') {
    targetLocale = 'en-nz';
  } else if (locale === 'ce') {
    targetLocale = 'en-ca';
  } else if (locale === 'en') {
    targetLocale = 'en-us';
  } else if (locale === 'tr') {
    targetLocale = 'tr-tr';
  }

  let pathname = '';

  if (page) {
    const [path, search] = page.split('?');
    pathname = `${pathname}${path}`;

    if (search) {
      qp = {
        ...qp,
        ...parseQueryString(search, { ignoreQueryPrefix: true }),
      };
    }
  } else if (isLive) {
    pathname = `${pathname}/live`;
  }

  qp.theme = isDark ? 'dark' : 'light';
  qp.locale = targetLocale;

  return `https://tamcasino-sportsbook-${getSportsbookEnv()}.gtdevteam.work${pathname}${stringifyQueryString(
    qp,
    { addQueryPrefix: true, skipNulls: true },
  )}`;
};

class SportsbookUI extends Component {
  static propTypes = {
    openModal: PropTypes.func.isRequired,
    changeLocale: PropTypes.func.isRequired,
    history: PropTypes.shape().isRequired,
    isPwa: PropTypes.bool.isRequired,
    isLive: PropTypes.bool,
    locale: PropTypes.string.isRequired,
    currentPage: PropTypes.string.isRequired,
    isSignUpCompleted: PropTypes.bool.isRequired,
    isUserLoggedIn: PropTypes.bool.isRequired,
    isUserRegistered: PropTypes.bool.isRequired,
    signOut: PropTypes.func.isRequired,
    location: PropTypes.shape().isRequired,
    games: PropTypes.arrayOf(PropTypes.shape()),
    userData: PropTypes.shape(),
    userBalance: PropTypes.shape(),
    loyaltyPoints: PropTypes.shape(),
    intl: intlShape.isRequired,
    themeMode: PropTypes.bool,
  };

  static defaultProps = {
    userData: {},
    userBalance: null,
    loyaltyPoints: null,
    games: [],
    isLive: false,
    themeMode: true,
  };

  constructor(props) {
    super(props);
    const { location: { search }, userData: { sessionKey } } = props;

    this.state = {
      isMounted: false,
      isLoggedIn: !!sessionKey,
      page: parsePage(search),
      isSearchOpen: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const { location: { search }, userData: { sessionKey } } = props;
    const { isLoggedIn } = state;

    if (sessionKey && !isLoggedIn) {
      return {
        isLoggedIn: true,
        page: parsePage(search),
      };
    }

    if (isLoggedIn && !sessionKey) {
      return {
        isLoggedIn: false,
        page: parsePage(search),
      };
    }

    return null;
  }

  componentDidMount() {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    window.addEventListener('message', this.onIframeMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.onIframeMessage);
  }

  onIframeMessage = ({ data: messageData }) => {
    const {
      openModal,
      changeLocale,
      history,
      isPwa,
      locale,
      isSignUpCompleted,
      isUserRegistered,
      isUserLoggedIn,
      signOut,
      location: { search },
      intl: { formatMessage },
    } = this.props;

    const { type, data } = messageData || {};

    if (type === SPORTSBOOK_POST_MESSAGE_TYPES.UNAUTHORIZED || type === SPORTSBOOK_POST_MESSAGE_TYPES.SIGN_IN) {
      openModal({ id: MODAL_IDS.SIGN_IN });
    } else if (type === SPORTSBOOK_POST_MESSAGE_TYPES.CLICK_DMCA) {
      window.open('https://www.dmca.com/Protection/Status.aspx?ID=f2e5cc76-367a-4efd-9e18-c1645e827177');
    } else if (type === SPORTSBOOK_POST_MESSAGE_TYPES.SIGN_UP) {
      openModal({ id: MODAL_IDS.SIGN_UP });
    } else if (type === SPORTSBOOK_POST_MESSAGE_TYPES.MOUNTED) {
      this.setState({ isMounted: true });
    } else if (type === SPORTSBOOK_POST_MESSAGE_TYPES.DEPOSIT) {
      openModal(isSignUpCompleted ? MODAL_IDS.DEPOSIT : MODAL_IDS.COMPLETE_SIGN_UP);
    } else if (type === SPORTSBOOK_POST_MESSAGE_TYPES.CHANGE_LOCALE) {
      let targetLocale = data.locale;
      const splittedLocale = data.locale.split('-');

      if (ES_LOCALES_LIST.includes(splittedLocale[1])) {
        targetLocale = splittedLocale[1];
      } else if (data.locale === 'pt-br') {
        targetLocale = 'br';
      } else if (data.locale === 'en-au') {
        targetLocale = 'au';
      } else if (data.locale === 'en-nz') {
        targetLocale = 'nz';
      } else if (data.locale === 'en-ca') {
        targetLocale = 'ce';
      } else if (locale === 'en') {
        targetLocale = 'en-us';
      } else if (locale === 'tr') {
        targetLocale = 'tr-tr';
      }

      changeLocale({ locale: targetLocale });
    } else if (type === SPORTSBOOK_POST_MESSAGE_TYPES.CLICK_FOOTER_LINK) {
      if (data.group === 2 && data.idx === 0) {
        openModal(MODAL_IDS.SUPPORT);
      } else {
        history.push(wrapRoute2Locale(`${prepareFooterLink(data.group, data.idx, formatMessage)}${isPwa ? '?launch_from=pwa' : ''}`, locale));
      }
      // else if (data.group === 3) {
      //   window.open(prepareFooterLink(data.group, data.idx, formatMessage), '_blank');
      // }
    } else if (type === SPORTSBOOK_POST_MESSAGE_TYPES.CLICK_LOGO) {
      history.push(wrapRoute2Locale(`/${isPwa ? '?launch_from=pwa' : ''}`, locale));
    } else if (type === SPORTSBOOK_POST_MESSAGE_TYPES.CLICK_HEADER_LINK) {
      if (data.idx !== 0) {
        history.push(wrapRoute2Locale(`${prepareHeaderLink(data.idx)}${isPwa ? '?launch_from=pwa' : ''}`, locale));
      }
    } else if (type === SPORTSBOOK_POST_MESSAGE_TYPES.CLICK_USER_ACTION) {
      if (data.idx === 7) {
        signOut();
      } else {
        history.push(wrapRoute2Locale(`${prepareProfileLink(data.idx)}${isPwa ? '?launch_from=pwa' : ''}`, locale));
      }
    } else if (type === SPORTSBOOK_POST_MESSAGE_TYPES.CHANGE_LOCATION) {
      let matched;

      try {
        matched = search && decodeURIComponent(search).match(/(.*)page=/);
      } catch (_) {
        //
      }

      const searchWithoutPage = matched && matched.legnth > 1 ? matched[1] : '';
      const qp = {
        ...parseQueryString(searchWithoutPage, { ignoreQueryPrefix: true }),
      };

      if (data.location !== '/') {
        qp.page = data.location;
      }

      history.replace({
        search: stringifyQueryString(qp, { encode: false }),
      });
    } else if (type === SPORTSBOOK_POST_MESSAGE_TYPES.CLICK_CHECK_IN) {
      let checkInModalData;

      if (isUserLoggedIn) {
        checkInModalData = MODAL_IDS.CHECK_IN;
      } else if (isUserRegistered) {
        checkInModalData = { id: MODAL_IDS.AUTH, data: AUTH_TYPES.SIGN_IN };
      } else {
        checkInModalData = { id: MODAL_IDS.AUTH, data: AUTH_TYPES.SIGN_UP };
      }

      openModal(checkInModalData);
    } else if (type === SPORTSBOOK_POST_MESSAGE_TYPES.CLICK_MENU) {
      openModal(SIDE_MODAL_IDS.SIDE_MODAL_BAR);
    } else if (type === SPORTSBOOK_POST_MESSAGE_TYPES.CLICK_SEARCH) {
      this.onSearchOpen();
    } else if (type === SPORTSBOOK_POST_MESSAGE_TYPES.CLICK_PAYMENTS) {
      if (isUserLoggedIn) {
        history.push(wrapRoute2Locale(`/profile/deposit${isPwa ? '?launch_from=pwa' : ''}`, locale));
      } else {
        openModal({ id: MODAL_IDS.AUTH, data: AUTH_TYPES.SIGN_UP });
      }
    } else if (type === SPORTSBOOK_POST_MESSAGE_TYPES.CLICK_BANNER) {
      history.push(wrapRoute2Locale(`${data.link}${isPwa ? '?launch_from=pwa' : ''}`, locale));
    }
  };

  onSearchOpen = () => this.setState({ isSearchOpen: true });

  onSearchClose = () => this.setState({ isSearchOpen: false });

  openModal = () => {
    const { openModal, isSignUpCompleted } = this.props;

    openModal(isSignUpCompleted ? MODAL_IDS.DEPOSIT : MODAL_IDS.COMPLETE_SIGN_UP);
  };

  depositClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    GA.event({ category: 'deposit', action: 'click', label: 'DepFirst' });
    YM.event('DepFirst');

    this.openModal();
  };

  render() {
    const {
      locale,
      userData,
      games,
      isUserLoggedIn,
      location: { search },
      userBalance,
      loyaltyPoints,
      signOut,
      currentPage,
      isLive,
      themeMode,
    } = this.props;

    const {
      isMounted,
      page,
      isSearchOpen,
    } = this.state;

    let src = '';

    if (canUseDOM()) {
      src = prepareIframeSrc({
        locale,
        sessionKey: userData.sessionKey,
        currency: userData.currency,
        parent: window.location.hostname,
        page,
        isLive,
        isDark: !themeMode,
      });
    }

    const userInfoIsFetched = R.none(isEmptyOrNil, [userData, userBalance, loyaltyPoints]);

    return (
      <div className="sportsbook">
        <div className="sports-header d-none d-lg-flex justify-content-between align-items-center w-100 px-md-1 px-lg-3 position-relative">
          <RouteLink to="/">
            <IconLogo />
          </RouteLink>

          <CasinoHeader
            className="casino-header-sports position-absolute"
            isSticky={false}
          >
            {menuItems.map(({
              id, to, Icon, pages
            }) => (
              <RouteLink
                key={id}
                to={to}
                className="header-item h4 mr-1 mr-lg-3_75 d-flex align-items-center flex-shrink-0"
              >
                <Icon
                  className={classNames('header-icon mb-0_25 mr-1 flex-shrink-0', {
                    active: search === '?page=/live/1'
                      ? pages.includes(`/${currentPage}${search}`)
                      : pages.includes(currentPage)
                  })}
                />

                <FormattedTag
                  id={id}
                  className="text-capitalize"
                />
              </RouteLink>
            ))}
          </CasinoHeader>

          <div className="d-flex align-items-center flex-shrink-0">
            {isUserLoggedIn ? (
              <>
                <DropdownWithHover>
                  <DropdownToggle
                    tag="div"
                    className="d-flex align-items-center cursor-pointer sportsbook-dropdown-toggle"
                  >
                    <span className="mr-1">
                      <IconUser className="icon-user" />
                    </span>

                    <UserBalance isSportsPage />
                  </DropdownToggle>

                  <DropdownMenu
                    className="sportsbook-dropdown-menu pb-3_5 mr-n1_5"
                    right
                    flip
                  >
                    <div className="mx-3">
                      <UserInfoAndLoyalty
                        userBalance={userBalance}
                        userInfoIsFetched={userInfoIsFetched}
                      />

                      <SidebarMenu
                        onMenuItemClick={this.onMenuItemClick}
                        pageName="/sportsbook"
                        isGridView
                      />

                      <FormattedTag
                        tag={Button}
                        id="sign-out"
                        color="gray-10-50"
                        onClick={signOut}
                        block
                        outline
                      />
                    </div>
                  </DropdownMenu>
                </DropdownWithHover>

                <Button
                  onClick={this.depositClick}
                  color="primary"
                  size="sm"
                  className="py-lg-1_25 px-2_5"
                >
                  <FormattedMessage id="deposit" />
                </Button>
              </>
            ) : (
              <SignInButtons />
            )}
          </div>
        </div>

        <div className="casino-header-mobile bg-white bg-switch-dark d-flex d-lg-none align-items-center justify-content-between px-2">
          <CasinoHeaderMobile isSportsPage />
        </div>

        {src && (
          /* eslint-disable-next-line jsx-a11y/iframe-has-title */
          <iframe
            src={src}
            className="sportsbook-iframe"
            frameBorder="0"
            width="100%"
            allow="autoplay"
            allowFullScreen
          />
        )}

        {!isMounted && <SportsbookSpinner />}

        {isSearchOpen && (
          <GamesSearchPortal
            recommendedGames={games}
            onSearchClose={this.onSearchClose}
          />
        )}

        <ProfileModal />
      </div>
    );
  }
}

export const Sportsbook = withRouter(
  withUserAgent(
    withThemeMode(
      withModalActions(
        withUser(
          withCoreComponent(
            RecommendedGamesCore,
            withCoreComponent(
              LangSwitcherCore,
              injectIntl(SportsbookUI),
            )
          ), [
            USER_FIELDS.USER_DATA,
            USER_FIELDS.IS_SIGN_UP_COMPLETED,
            USER_FIELDS.IS_USER_REGISTERED,
            USER_FIELDS.IS_USER_LOGGED_IN,
            USER_FIELDS.SESSION_KEY,
            USER_FIELDS.USER_BALANCE,
            USER_FIELDS.LOYALTY_POINTS,
          ],
        )
      )
    )
  )
);
